import React from 'react';
var ErrorImg = function () {
  return React.createElement("svg", {
    width: '300',
    height: '157',
    viewBox: '0 0 300 157',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("g", {
    clipPath: 'url(#clip0_7_4422)'
  }, React.createElement("mask", {
    id: 'mask0_7_4422',
    style: {
      maskType: 'luminance'
    },
    maskUnits: 'userSpaceOnUse',
    x: '22',
    y: '0',
    width: '269',
    height: '157'
  }, React.createElement("rect", {
    x: '22.2875',
    width: '268.618',
    height: '156.857',
    fill: 'white'
  })), React.createElement("g", {
    mask: 'url(#mask0_7_4422)'
  }, React.createElement("path", {
    d: 'M252.999 134.309H142.047H31.0951C31.0951 72.9461 80.77 23.2018 142.047 23.2018C203.324 23.2018 252.999 72.9461 252.999 134.309Z',
    fill: '#99C3F9'
  }), React.createElement("ellipse", {
    cx: '46.759',
    cy: '132.348',
    rx: '24.4747',
    ry: '24.5089',
    fill: '#EDFF7A'
  }), React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M263.081 -10.265C263.081 -17.3118 260.05 -24.5848 252.493 -30.1004C245.197 -35.6369 233.847 -38.125 221.519 -38.125C204.895 -38.125 194.558 -33.8517 189.023 -28.8511C184.231 -24.3307 181.465 -17.799 181.465 -11.5178C181.465 7.29448 201.867 15.5836 222.532 15.5836C239.715 15.5836 257.905 10.9178 262.201 -4.52859L262.327 -4.99997C262.787 -6.66482 263.052 -8.32655 263.079 -9.98811L263.081 -10.265ZM287.235 -41.0722H274.907L275.51 -40.5732C276.814 -39.4915 278.089 -38.4055 279.18 -37.3222C285.488 -30.7866 290.731 -18.9864 290.731 -4.40754C290.731 27.7376 266.35 52.6125 222.569 52.6125C195.662 52.6125 153.862 40.7878 153.862 -4.17076C153.862 -15.3777 156.696 -22.4248 160.874 -29.782L161.202 -30.356L161.536 -30.9318L161.875 -31.5097C161.931 -31.6062 161.989 -31.7028 162.046 -31.7996L162.392 -32.3817L162.92 -33.2613L163.639 -34.4486L164.938 -36.577H110.842V-75.4875H287.235V-41.0722Z',
    fill: '#0068EF'
  })), React.createElement("g", {
    filter: 'url(#filter0_d_7_4422)'
  }, React.createElement("g", {
    clipPath: 'url(#clip1_7_4422)'
  }, React.createElement("path", {
    d: 'M82.7428 54.1408C82.7428 49.6872 86.3532 46.0768 90.8069 46.0768H205.72C210.173 46.0768 213.784 49.6872 213.784 54.1409V62.2049H82.7428V54.1408Z',
    fill: 'white'
  }), React.createElement("path", {
    d: 'M82.7428 54.1408C82.7428 49.6872 86.3532 46.0768 90.8069 46.0768H205.72C210.173 46.0768 213.784 49.6872 213.784 54.1409V62.2049H82.7428V54.1408Z',
    stroke: '#C0CAD5',
    strokeWidth: '0.336003'
  }), React.createElement("path", {
    d: 'M90.1242 55.9025C90.3815 55.9025 90.5821 55.7941 90.7258 55.5771C90.8722 55.3577 90.9453 55.0524 90.9453 54.6614C90.9453 54.273 90.8734 53.9715 90.7296 53.7571C90.5858 53.5402 90.384 53.4317 90.1242 53.4317C89.8669 53.4317 89.6638 53.5402 89.515 53.7571C89.3687 53.974 89.2956 54.2755 89.2956 54.6614C89.2956 55.0499 89.3687 55.3539 89.515 55.5733C89.6638 55.7928 89.8669 55.9025 90.1242 55.9025ZM88.1188 58.101V52.6711H89.201V53.0571C89.3473 52.8956 89.5201 52.7758 89.7193 52.6976C89.9186 52.6169 90.1469 52.5765 90.4042 52.5765C90.9415 52.5765 91.3641 52.7619 91.6718 53.1328C91.9796 53.5011 92.1334 54.0106 92.1334 54.6614C92.1334 55.3022 91.972 55.8193 91.6491 56.2128C91.3287 56.6038 90.9087 56.7993 90.3891 56.7993C90.1671 56.7993 89.9653 56.7665 89.7837 56.7009C89.6046 56.6353 89.4419 56.5344 89.2956 56.3982V58.101H88.1188Z',
    fill: '#0068EF'
  }), React.createElement("path", {
    d: 'M93.7567 54.2452H95.3346C95.3043 53.9778 95.2211 53.7722 95.0848 53.6284C94.9486 53.4847 94.7683 53.4128 94.5438 53.4128C94.3218 53.4128 94.1427 53.4847 94.0065 53.6284C93.8728 53.7697 93.7895 53.9753 93.7567 54.2452ZM93.7491 54.9641C93.7592 55.3072 93.84 55.5708 93.9913 55.755C94.1452 55.9366 94.3609 56.0274 94.6384 56.0274C94.8477 56.0274 95.0319 55.9656 95.1908 55.842C95.3497 55.7184 95.4834 55.5342 95.5919 55.2896L96.466 55.7247C96.2818 56.1031 96.022 56.3907 95.6865 56.5874C95.3535 56.7817 94.9549 56.8788 94.4908 56.8788C93.9005 56.8788 93.4326 56.6908 93.087 56.315C92.7414 55.9366 92.5686 55.427 92.5686 54.7863C92.5686 54.1128 92.7515 53.5717 93.1172 53.163C93.4855 52.7519 93.9674 52.5463 94.5627 52.5463C95.1555 52.5463 95.6247 52.7443 95.9703 53.1403C96.3184 53.5364 96.4924 54.0775 96.4924 54.7636C96.4924 54.7838 96.4899 54.8166 96.4849 54.862C96.4824 54.9074 96.4811 54.9414 96.4811 54.9641H93.7491Z',
    fill: '#0068EF'
  }), React.createElement("path", {
    d: 'M97.1698 56.7388V52.6711H98.3465V53.0495C98.4979 52.8906 98.6682 52.772 98.8574 52.6938C99.0491 52.6156 99.2635 52.5765 99.5006 52.5765C99.9244 52.5765 100.24 52.7165 100.447 52.9965C100.653 53.2765 100.757 53.7054 100.757 54.2831V56.7388H99.5725V54.3436C99.5725 54.0686 99.5258 53.8668 99.4325 53.7382C99.3417 53.6095 99.1966 53.5452 98.9974 53.5452C98.7628 53.5452 98.595 53.6057 98.4941 53.7268C98.3957 53.8454 98.3465 54.051 98.3465 54.3436V56.7388H97.1698Z',
    fill: '#0068EF'
  }), React.createElement("path", {
    d: 'M101.62 56.7388V52.6711H102.796V53.0495C102.948 52.8906 103.118 52.772 103.307 52.6938C103.499 52.6156 103.713 52.5765 103.95 52.5765C104.374 52.5765 104.69 52.7165 104.896 52.9965C105.103 53.2765 105.207 53.7054 105.207 54.2831V56.7388H104.022V54.3436C104.022 54.0686 103.976 53.8668 103.882 53.7382C103.791 53.6095 103.646 53.5452 103.447 53.5452C103.213 53.5452 103.045 53.6057 102.944 53.7268C102.846 53.8454 102.796 54.051 102.796 54.3436V56.7388H101.62Z',
    fill: '#0068EF'
  }), React.createElement("path", {
    d: 'M105.604 52.6711H106.868L107.549 55.615L108.238 52.6711H109.479L108.132 56.8712C107.968 57.3833 107.78 57.7276 107.568 57.9042C107.358 58.0833 107.054 58.1729 106.656 58.1729C106.545 58.1729 106.435 58.1691 106.327 58.1615C106.218 58.1539 106.111 58.1426 106.005 58.1274L106.009 57.1664C106.087 57.1739 106.159 57.179 106.225 57.1815C106.29 57.1865 106.344 57.1891 106.387 57.1891C106.589 57.1891 106.732 57.1626 106.815 57.1096C106.901 57.0591 106.943 56.9746 106.943 56.8561C106.943 56.8081 106.932 56.7438 106.909 56.6631C106.889 56.5824 106.851 56.46 106.796 56.2961L105.604 52.6711Z',
    fill: '#0068EF'
  }), React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M111.461 50.1088C111.325 51.5892 111.214 51.6988 109.735 51.8353C111.214 51.971 111.325 52.0822 111.461 53.5619C111.598 52.0822 111.708 51.971 113.188 51.8353C111.708 51.6989 111.598 51.5892 111.461 50.1088ZM108.479 50.9951C108.988 51.0414 109.026 51.0776 109.073 51.5686C109.12 51.0776 109.158 51.0414 109.666 50.9951C109.158 50.9499 109.12 50.9139 109.073 50.4227C109.026 50.9139 108.988 50.9499 108.479 50.9951ZM110.834 53.5619C110.896 54.2339 110.946 54.2841 111.619 54.3462C110.946 54.4074 110.896 54.4588 110.834 55.1315C110.772 54.4588 110.722 54.4074 110.049 54.3462C110.722 54.2841 110.772 54.2339 110.834 53.5619Z',
    fill: 'url(#paint0_linear_7_4422)'
  }), React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M206.728 52.2592L206.257 51.7888L204.376 53.6704L202.494 51.7888L202.024 52.2592L203.905 54.1408L202.024 56.0225L202.494 56.4929L204.376 54.6112L206.257 56.4929L206.728 56.0225L204.846 54.1408L206.728 52.2592Z',
    fill: '#001833'
  }), React.createElement("g", {
    clipPath: 'url(#clip2_7_4422)'
  }, React.createElement("rect", {
    width: '131.041',
    height: '237.554',
    transform: 'translate(82.7428 62.2048)',
    fill: 'white'
  }), React.createElement("g", {
    clipPath: 'url(#clip3_7_4422)'
  }, React.createElement("rect", {
    width: '131.041',
    height: '237.554',
    transform: 'translate(82.7428 62.0892)',
    fill: 'white'
  }), React.createElement("circle", {
    cx: '123.945',
    cy: '95.0724',
    r: '6.43731',
    fill: '#001833'
  }), React.createElement("circle", {
    cx: '172.582',
    cy: '95.0724',
    r: '6.43731',
    fill: '#001833'
  }), React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M140.529 108.077C140.833 108.329 141.284 108.288 141.537 107.985C142.638 106.663 144.782 105.053 147.578 104.585C150.338 104.123 153.825 104.759 157.688 108.07C157.988 108.327 158.439 108.292 158.696 107.993C158.954 107.693 158.919 107.241 158.619 106.984C154.471 103.429 150.567 102.634 147.342 103.174C144.154 103.707 141.72 105.53 140.438 107.069C140.185 107.373 140.226 107.824 140.529 108.077Z',
    fill: '#001833'
  })))))), React.createElement("defs", null, React.createElement("filter", {
    id: 'filter0_d_7_4422',
    x: '61.9106',
    y: '17.1805',
    width: '172.705',
    height: '129.897',
    filterUnits: 'userSpaceOnUse',
    colorInterpolationFilters: 'sRGB'
  }, React.createElement("feFlood", {
    floodOpacity: '0',
    result: 'BackgroundImageFix'
  }), React.createElement("feColorMatrix", {
    in: 'SourceAlpha',
    type: 'matrix',
    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
    result: 'hardAlpha'
  }), React.createElement("feMorphology", {
    radius: '0.672006',
    operator: 'erode',
    in: 'SourceAlpha',
    result: 'effect1_dropShadow_7_4422'
  }), React.createElement("feOffset", {
    dy: '-8.06407'
  }), React.createElement("feGaussianBlur", {
    stdDeviation: '10.7521'
  }), React.createElement("feComposite", {
    in2: 'hardAlpha',
    operator: 'out'
  }), React.createElement("feColorMatrix", {
    type: 'matrix',
    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'
  }), React.createElement("feBlend", {
    mode: 'normal',
    in2: 'BackgroundImageFix',
    result: 'effect1_dropShadow_7_4422'
  }), React.createElement("feBlend", {
    mode: 'normal',
    in: 'SourceGraphic',
    in2: 'effect1_dropShadow_7_4422',
    result: 'shape'
  })), React.createElement("linearGradient", {
    id: 'paint0_linear_7_4422',
    x1: '112.246',
    y1: '50.4227',
    x2: '108.896',
    y2: '53.7319',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement("stop", {
    stopColor: '#7601B9'
  }), React.createElement("stop", {
    offset: '0.601433',
    stopColor: '#7701BB'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#0068EF'
  })), React.createElement("clipPath", {
    id: 'clip0_7_4422'
  }, React.createElement("rect", {
    width: '300',
    height: '156.8',
    fill: 'white'
  })), React.createElement("clipPath", {
    id: 'clip1_7_4422'
  }, React.createElement("path", {
    d: 'M82.7428 54.1408C82.7428 49.6872 86.3532 46.0768 90.8069 46.0768H205.72C210.173 46.0768 213.784 49.6872 213.784 54.1408V134.309H82.7428V54.1408Z',
    fill: 'white'
  })), React.createElement("clipPath", {
    id: 'clip2_7_4422'
  }, React.createElement("rect", {
    width: '131.041',
    height: '237.554',
    fill: 'white',
    transform: 'translate(82.7428 62.2048)'
  })), React.createElement("clipPath", {
    id: 'clip3_7_4422'
  }, React.createElement("rect", {
    width: '131.041',
    height: '237.554',
    fill: 'white',
    transform: 'translate(82.7428 62.0892)'
  }))));
};
export default ErrorImg;